
export interface RxScanMode {
	title: string
	value: string
}

export const RX_SCAN_MODES: RxScanMode[] = [
    {title: "Five / Seven", value: "fiveSeven"},
    {title: "Eight", value: "eight"},
    {title: "Five / Seven + 2s Buffer", value: "fiveSevenBuffered"},
    {title: "Eight + 2s Buffer", value: "eightBuffered"},
    {title: "∞", value: "normal"},
]
